import { render, staticRenderFns } from "./CustomerPrototypeItem.vue?vue&type=template&id=7e8463d0&scoped=true"
import script from "./CustomerPrototypeItem.vue?vue&type=script&lang=js"
export * from "./CustomerPrototypeItem.vue?vue&type=script&lang=js"
import style0 from "./CustomerPrototypeItem.vue?vue&type=style&index=0&id=7e8463d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8463d0",
  null
  
)

export default component.exports